

import {
    Tooltip,
    TableCell
} from "@material-ui/core";
import React, { ReactElement } from "react";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./pqIndexStyle";
import { round4Digits } from "../../../utils/utils";

export default function ColorValues(
    props: { value: number }
): ReactElement {

    const classes = {

        ...globalStyles(),
        ...useStyles()
    };

    const value = props.value;

    if (value == 11 || value == 10 || value === null || value === undefined) {
        return (
            <Tooltip title="Keine Daten">
                <TableCell className={classes.tableCellKursivStyle}></TableCell>
            </Tooltip>
        )
    }
    else if (value < 10 && value >= 0.5) {
        return (
            <Tooltip title={round4Digits(value)}>
                <TableCell className={classes.tableCellStyle} style={{ backgroundColor: "#99cc99" }}></TableCell>
            </Tooltip>
        )
    } else if (value >= 0.0 && value < 0.5) {
        return (
            <Tooltip title={round4Digits(value)}>
                <TableCell className={classes.tableCellStyle} style={{ backgroundColor: "#ffd27f" }} ></TableCell>
            </Tooltip>
        )
    } else if (value < 0.0)
        return (
            <Tooltip title={round4Digits(value)}>
                <TableCell className={classes.tableCellStyle} style={{ backgroundColor: "#e39999" }}></TableCell>
            </Tooltip>
        )
    else {
        return (
            <Tooltip title="Keine Daten">
                <TableCell className={classes.tableCellStyle}></TableCell>
            </Tooltip>
        )
    }

}